import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { Tab } from "../../../Tab";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { PropsWithTsId } from "../../../../../types/react";
import type { TabProps } from "../../../Tab";

export const TABS_VIEW_TAB_TEST_ID = "tabs-view-tab-test-id";

/** Инкапсулируем работу с selected внутрь TabsView */
export type TabsViewTabProps = Omit<TabProps, "selected" | "data-tsid"> &
    Partial<PropsWithTsId>;

const TabsViewTab = createComponentPreset<
    BoxComponentWithDefault<"button", TabsViewTabProps>,
    typeof Tab
>("TabsView.Tab", Tab, {
    "data-tsid": TABS_VIEW_TAB_TEST_ID,
});

export default TabsViewTab;
